import BaseGuideText from "../../../../src/entities/BaseGuideText";
import { GUIDE_TEXT_TANGENT_COORD, PURPLE_COLORS } from "../types/Config";


const text = "Select the points to swap the tangent";
const color = PURPLE_COLORS[0]


export default class GuideTextTangent extends BaseGuideText {
  constructor() {
    super(text, color, GUIDE_TEXT_TANGENT_COORD, 40);
  }
}